import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import HiddenDiv from 'components/core/HiddenDiv.component';
import selectIsLoggedIn from 'selectors/selectIsLoggedIn.selector';
import { isEnvCy } from 'utils/env/determine.util';
import logger from 'utils/logger.util';

const L = logger('LoginWatcher');

const LoginWatcher = ({ isLoggedIn }) => {
  // FIXME: Cypress tests don't use Cognito, but mock it, they would have isLoggedIn === false and fail, fix them first

  // placeholder can be null just as well,
  // but it's nice to be able to verify it's there by seeing it in the browser inspect tab
  // if in the process of logging in, isLoggedIn is neither true nor false, the placeholder is used

  const placeholder = <HiddenDiv tag="LoginWatcher--hiden" />;

  const isCypress = isEnvCy();
  L.debug('()', { isLoggedIn, isCypress });

  if (isCypress) return placeholder;
  if (isLoggedIn === false) return <Redirect to="/login" />;

  return placeholder;
};

const LoginWatcherHoc = connect((state) => ({
  isLoggedIn: selectIsLoggedIn(state),
}))(LoginWatcher);

export default LoginWatcherHoc;
